import { useCallback, useState } from 'react';
import { useAuth } from '@/contexts/AuthContext';

export function useGroupVoteAuthGate() {
  const { user } = useAuth();
  const [showModal, setShowModal] = useState(false);

  const requireAuth = useCallback(
    (onSuccess: () => void) => {
      if (user) {
        onSuccess();
        return;
      }
      setShowModal(true);
    },
    [user]
  );

  const closeModal = useCallback(() => setShowModal(false), []);

  return { requireAuth, isAuthenticated: !!user, showModal, closeModal };
}
